{
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "welcome": "Welcome, {{name}}",
    "back": "Back",
    "send": "Send",
    "submit": "Submit",
    "sending": "Sending...",
    "backToLogin": "Back to Login",
    "loginNow": "Login Now"
  },
  "auth": {
    "login": "Login",
    "email": "Email",
    "password": "Password"
  },
  "errorCard": {
    "title": "Sorry! Something went wrong!",
    "refreshPage": "Please refresh the page",
    "orBack": " or go back.",
    "orHome": " or go Home.",
    "refreshBtn": "Refresh",
    "backBtn": "Go Back"
  },
  "confirmEmail": {
    "verifying": "Verifying your Email...",
    "verified": "Email Verified Successfully!"
  },
  "createBtn": "Create Pitch",
  "replyCall": "Reply to call",
  "sidebar": {
    "pitches": "Pitches",
    "calls": "Call for Pitches",
    "commissions": "Commissions",
    "faq": "FAQ",
    "safety": "Safety Guidelines",
    "terms": "Terms & Conditions",
    "support": "Support"
  },
  "support": {
    "general": "General Enquiry",
    "tech": "Technical Support",
    "finance": "Finance Enquiry",
    "supportType": "Support Type",
    "subject": "Subject",
    "description": "Description",
    "confirmation": "Message Sent Successfully."
  },
  "navbar": {
    "langSwitch": "Switch Language",
    "lang": "Language",
    "logout": "Logout"
  },
  "richEditor": {
    "placeholder": "Start typing your pitch..."
  },
  "pitch": {
    "discussion": "Discussion",
    "finalVersion": "Final Version",
    "commissioningOffer": "CommissioningOffer",
    "attach": "Attachments",
    "approveFinal": "Approve Final Version",
    "approvedFinal": "Final Version Approved"
  },
  "pitchGuidelines": {
    "title": "How to create a perfect pitch?",
    "disclaimer": "DISCLAIMER: Following these guidelines will increase the chance of your pitch’s acceptance",
    "ol1": "Every pitch needs to have a main character and start with a strong hook that sums up the story.",
    "ol2": "The pitch should explain in no more than 300 words:",
    "ol3": "In the case of solutions journalism(Egab’s speciality), the pitch needs to answer another question:",
    "ul1-1": "What is the story?",
    "ul1-2": "Why this story? (Why should global audiences care? Or simply: So What?)",
    "ul1-3": "Why now ? (Sometimes there is a peg like a forthcoming international day or event. But in most times the mere passage of enough time to be able to evaluate an initiative is enough)",
    "ul1-4": "Why you are the best person to cover this story? Why you?",
    "ul2-1": "How it works ? (What’s new or different about this solution & why it works)",
    "pitchExamplesBtn": "Show Pitch Examples"
  },
  "forget": {
    "pageTitle": "Forget Password",
    "title": "Write your email to get a reset Link!",
    "successTitle": "Check the link in your email to complete password reset."
  },
  "reset": {
    "pageTitle": "Reset Password",
    "title": "Choose new Password",
    "successTitle": "Password Reset Successfully!",
    "subtitle": "You can now login with the new password.",
    "submit": "Submit",
    "submitting": "Submitting..."
  },
  "status": {
    "all": "All",
    "saved": "Saved",
    "submitted": "Submitted",
    "review": "Under Review",
    "editorComment": "Editor Comment",
    "journalistComment": "Journalist Comment",
    "approved": "Approved",
    "rejected": "Rejected",
    "commissioned": "Commissioned",
    "commissioningOffer": "Commissioning Offer",
    "callPublished": "Published",
    "callExpired": "Expired"
  },
  "pitchCard": {
    "editor": "Editor"
  },
  "comments": {
    "title": "Comments",
    "placeholder": "Write a comment...",
    "closed": "Comments are closed on this pitch!",
    "comment": "Comment",
    "voice": "Voice Message",
    "stop": "Stop",
    "record": "Recording"
  },
  "page": {
    "next": "Next",
    "previous": "Previous",
    "result": "Results"
  },
  "details": {
    "title": "Details",
    "status": "Status",
    "posted": "Posted",
    "lang": "Language",
    "loc": "Location",
    "format": "Formats",
    "themes": "Themes",
    "deadline": "Deadline",
    "budget": "Budget",
    "editor": "Editor",
    "journalist": "Journalist",
    "submit": "Submit Pitch"
  },
  "create": {
    "pageTitle": "Create Pitch",
    "title": "Title",
    "titlePlaceholder": "Pitch Title",
    "content": "Content",
    "attachments": "Attachments",
    "select": "Select ",
    "lang": "Language",
    "loc": "Location",
    "format": "Formats",
    "themes": "Themes",
    "submit": "Submit Pitch",
    "save": "Save",
    "saving": "Saving...",
    "submitting": "Submitting...",
    "cancel": "Cancel",
    "noItem": "No items found."
  },
  "uploadTitle": "Drop files here or click to upload",
  "uploadAccepted": "Accepted files",
  "signup": {
    "signup": "Signup",
    "title": "Create Journalist Account",
    "haveAccount": "Already have an account?",
    "signin": "Sign in",
    "email": "Email",
    "password": "Password",
    "repeatPassword": "Repeat Password",
    "continue": "Continue",
    "agreement": "By clicking Continue, you agree to our",
    "and": "and",
    "terms": "Terms of Service",
    "privacy": "Privacy Policy",
    "emailRequired": "Email is required",
    "emailInvalid": "Please enter a valid email",
    "repeatPasswordError": "Password mismatch.",
    "title2": "Complete your profile to start pitching",
    "firstName": "First Name",
    "lastName": "Last Name",
    "required": "required",
    "gender": "Gender",
    "whatsapp": "WhatsApp Phone",
    "code": "Code",
    "phone": "Phone",
    "city": "City",
    "title3": " Choose your expertise - we'll pitch your stories to interested outlets",
    "formatsTitle": "Formats you produce work in",
    "topicsTitle": "What topics do you write about? (max 5)",
    "submitting": "Creating Account...",
    "complete": "Complete Signup",
    "success": "Account Created Successfully!",
    "verify": "Please check your email to verify your account and start pitching.",
    "minLength": "At least 6 characters",
    "upperCase": "At least 1 uppercase character",
    "number": "At least 1 number",
    "special": "At least 1 special character ('\"!@#$*;&:?-+)"
  },
  "login": {
    "title": "Welcome to Egab!",
    "noAccount": "Don't have an account?",
    "signup": "Sign up",
    "error": "Wrong Credentials! Please check Email/Password",
    "email": "Email",
    "password": "Password",
    "repeatPassword": "Repeat Password",
    "forget": "Forgot your password?",
    "login": "Login",
    "continue": "Or continue with",
    "google": "Login with Google",
    "agreement": "By clicking Login, you agree to our",
    "and": "and",
    "terms": "Terms of Service",
    "privacy": "Privacy Policy"
  }
}
